export const AUTOCOMPLETE = 'off';

export const TEST_ID = 'dateInput';
